(function () {
  "use strict";

  var PAIRS = [
    ["image_content_6Ndnme", "image_content_n7pbNC"],
    ["image_content_N84ciX", "image_content_iUVARi"]
  ];
  var SOLO = "image_content_MVN8m9";

  function stripControls(root) {
    if (!root) return;
    root.querySelectorAll(".wr-mt-more").forEach(function (n) {
      if (n.dataset.wrMt === "1") n.remove();
    });
    root.querySelectorAll(".wr-mt-fade").forEach(function (n) { n.remove(); });
    root.querySelectorAll(".wr-mt-clamped").forEach(function (n) {
      n.classList.remove("wr-mt-clamped", "wr-mt-expanded");
      n.style.maxHeight = "";
      n.style.overflow = "";
      n.style.position = "";
    });
  }

  function findSection(main, suffix) {
    return main.querySelector(':scope > .shopify-section[id$="__' + suffix + '"], :scope > .wr-teaser-grid > .shopify-section[id$="__' + suffix + '"]');
  }

  function wrapGroup(main, suffixes, solo) {
    var sections = [];
    suffixes.forEach(function (suffix) {
      var el = findSection(main, suffix);
      if (el) sections.push(el);
    });
    if (sections.length === 0) return;
    // already wrapped together?
    var parent = sections[0].parentElement;
    if (parent && parent.classList.contains("wr-teaser-grid") && sections.every(function (s) { return s.parentElement === parent; })) {
      if (solo) parent.classList.add("wr-teaser-grid--solo");
      return;
    }
    var grid = document.createElement("div");
    grid.className = "wr-teaser-grid" + (solo ? " wr-teaser-grid--solo" : "");
    grid.setAttribute("data-wr-teaser-grid", "1");
    sections[0].parentNode.insertBefore(grid, sections[0]);
    sections.forEach(function (sec) {
      if (solo) sec.classList.add("wr-teaser-full");
      grid.appendChild(sec);
    });
  }

  function wrapTeasers() {
    var main = document.querySelector("#MainContent");
    if (!main) return;
    PAIRS.forEach(function (pair) { wrapGroup(main, pair, false); });
    wrapGroup(main, [SOLO], true);
  }

  function syncTeaser(root) {
    var media = root.querySelector(".image-with-text__media");
    var content = root.querySelector(".image-with-text__content");
    var textItem = root.querySelector(".image-with-text__text-item");
    var body = root.querySelector(".image-with-text__text");
    if (!media || !content || !textItem || !body) return;

    stripControls(root);

    var isTechSoloEarly = !!(root.closest('[id*="image_content_MVN8m9"]') || root.closest(".wr-teaser-full"));
    if (isTechSoloEarly) {
      textItem.style.width = "";
      textItem.style.height = "";
      textItem.style.minHeight = "";
      textItem.style.maxHeight = "";
      content.style.height = "";
      content.style.minHeight = "";
      content.style.maxHeight = "";
      content.style.width = "";
      body.classList.remove("wr-mt-clamped", "wr-mt-expanded");
      body.style.maxHeight = "none";
      body.style.overflow = "visible";
      return;
    }

    var mediaH = Math.round(media.getBoundingClientRect().height);
    var mediaW = Math.round(media.getBoundingClientRect().width);
    if (mediaH < 80 || mediaW < 80) return;

    textItem.style.width = mediaW + "px";
    textItem.style.height = "auto";
    textItem.style.minHeight = "0";
    textItem.style.maxHeight = "none";
    content.style.height = "auto";
    content.style.minHeight = "0";
    content.style.maxHeight = "none";
    content.style.overflow = "visible";
    body.style.maxHeight = "none";
    body.style.overflow = "visible";

    var natural = Math.round(content.scrollHeight);

    textItem.style.height = mediaH + "px";
    textItem.style.minHeight = mediaH + "px";
    textItem.style.maxHeight = mediaH + "px";
    content.style.height = "100%";
    content.style.minHeight = "100%";
    content.style.display = "flex";
    content.style.flexDirection = "column";
    content.style.boxSizing = "border-box";



    if (natural > mediaH + 24) {
      var heading = root.querySelector(".image-with-text__heading");
      var btn = root.querySelector("a.button, .button");
      var styles = window.getComputedStyle(content);
      var padY = (parseFloat(styles.paddingTop) || 0) + (parseFloat(styles.paddingBottom) || 0);
      var headingH = heading ? heading.getBoundingClientRect().height : 0;
      var btnH = btn ? btn.getBoundingClientRect().height : 0;
      var available = Math.max(48, mediaH - padY - headingH - btnH - 28);

      body.style.position = "relative";
      body.style.maxHeight = available + "px";
      body.style.overflow = "hidden";
      body.classList.add("wr-mt-clamped");

      var fade = document.createElement("div");
      fade.className = "wr-mt-fade";
      fade.setAttribute("aria-hidden", "true");
      body.appendChild(fade);

      var a = root.querySelector("a.button[href]");
      var href = a && a.getAttribute("href");
      if (href === "#") href = null;

      var more = document.createElement(href ? "a" : "button");
      more.className = "wr-mt-more";
      more.dataset.wrMt = "1";
      more.textContent = "Read more";
      if (href) more.href = href;
      else {
        more.type = "button";
        more.addEventListener("click", function () {
          var open = body.classList.toggle("wr-mt-expanded");
          if (open) {
            body.style.maxHeight = "none";
            more.textContent = "Read less";
            fade.style.display = "none";
          } else {
            body.style.maxHeight = available + "px";
            more.textContent = "Read more";
            fade.style.display = "";
          }
        });
      }
      body.insertAdjacentElement("afterend", more);
    }
  }

  function run() {
    wrapTeasers();
    document.querySelectorAll(".wr-teaser-grid .image-with-text, .image-with-text").forEach(function (root) {
      syncTeaser(root);
    });
  }

  var t;
  function schedule() {
    clearTimeout(t);
    t = setTimeout(run, 120);
  }

  window.wrMediaTextSync = run;
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", schedule);
  else schedule();
  window.addEventListener("load", schedule);
  window.addEventListener("resize", schedule);
  document.addEventListener("shopify:section:load", schedule);
})();


/* Paint Shopify Inbox activator brand red (agent shell ignores button_color) */
(function () {
  "use strict";
  var STYLE_ID = "wr-inbox-red-style";
  var CSS =
    '[part="activator"],button[part="activator"]{' +
    "background:#e10600!important;background-color:#e10600!important;" +
    "color:#fff!important;border-color:#e10600!important;" +
    "box-shadow:0 2px 10px rgba(225,6,0,.45)!important;}";

  function inject(root) {
    if (!root || root.getElementById(STYLE_ID)) return;
    var s = root.createElement
      ? root.createElement("style")
      : document.createElement("style");
    s.id = STYLE_ID;
    s.textContent = CSS;
    root.appendChild(s);
  }

  function walk(root, depth) {
    if (!root || depth > 6) return;
    inject(root);
    var nodes = root.querySelectorAll ? root.querySelectorAll("*") : [];
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.getAttribute && el.getAttribute("part") === "activator") {
        el.style.setProperty("background", "#e10600", "important");
        el.style.setProperty("background-color", "#e10600", "important");
        el.style.setProperty("color", "#ffffff", "important");
        el.style.setProperty("border-color", "#e10600", "important");
      }
      if (el.shadowRoot) walk(el.shadowRoot, depth + 1);
    }
  }

  function paint() {
    var host = document.querySelector("shopify-chat");
    if (!host || !host.shadowRoot) return false;
    walk(host.shadowRoot, 0);
    return true;
  }

  var tries = 0;
  function tick() {
    tries++;
    if (paint() || tries > 40) return;
    setTimeout(tick, 250);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", tick);
  else tick();
  window.addEventListener("load", function () { setTimeout(paint, 300); });
  var mo = new MutationObserver(function () { paint(); });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
